import { useAuth } from "../../../contexts/AuthContext";

const StudentCard = ({ isVisible, setIsStudentIDVisible, date }) => {
  // 学生証に表示する学生情報を取得する
  const { user } = useAuth();
  return (
    <div className={`p-student-id ${isVisible ? "is-visible" : ""}`}>
      <div className={`p-student-id__card`}>
        <div className="p-student-id__close">
          <a
            className="p-student-id__close-link"
            href="#"
            onClick={() => setIsStudentIDVisible(false)}
          >
            閉じる
          </a>
        </div>
        <p className="p-student-id__ttl">渋谷ハチコウ大学　学生証</p>
        <div className="p-student-id__con">
          <div className="p-studen-id__img">
            <img
              src="/common/assets/images/logo03.svg"
              alt="渋谷ハチコウ大学"
            />
          </div>
          <div className="p-student-id__detail">
            <dl className="p-student-id__table">
              <dt>学生番号</dt>
              <dd>{user.login_id}</dd>
              <dt>氏名</dt>
              <dd>{user.name}</dd>
              <dt>生年月日</dt>
              <dd>{user.birthday}</dd>
              <dt>発行年月日</dt>
              <dd>{user.date_issue_num}</dd>
              <dt>有効期限</dt>
              <dd>{user.expiration_date}</dd>
            </dl>
            <p className="p-student-id__txt01">
              上記の者は本学の学生であることを証明する
            </p>
            <p className="p-student-id__txt01">
              {process.env.REACT_APP_PRESIDENT_NAME}
            </p>
            <p className="p-student-id__display">表示日時：{date}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StudentCard;
